var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Box } from "@mui/material";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import { useElementConditions } from "../../context/FormLogicContext";
import { calculateRenderedMode, getCorrectImageLink, getLocaleText, getRenderedSize, getRenderedStyleSize, } from "./constants/image";
var ImageField = function (_a) {
    var element = _a.element;
    var _b = useState(false), contentNotLoaded = _b[0], setContentNotLoaded = _b[1];
    var isVisible = useElementConditions(element).isVisible;
    if (!isVisible)
        return null;
    var imageLink = getLocaleText(element.imageLink);
    var renderedMode = calculateRenderedMode(element.contentMode, imageLink);
    var locImageLink = getCorrectImageLink(imageLink, renderedMode === "youtube");
    var renderedAltText = getLocaleText(element.altText) || element.title;
    var imageFit = element.imageFit || "contain";
    var isDefaultSize = element.imageWidth === undefined && element.imageHeight === undefined;
    var renderedWidth = getRenderedSize(element.imageWidth);
    var renderedHeight = getRenderedSize(element.imageHeight);
    var renderedStyleWidth = getRenderedStyleSize(element.imageWidth);
    var renderedStyleHeight = getRenderedStyleSize(element.imageHeight);
    var style = __assign(__assign({ objectFit: imageFit, width: renderedStyleWidth || (renderedWidth ? "".concat(renderedWidth, "px") : undefined), height: renderedStyleHeight ||
            (renderedHeight ? "".concat(renderedHeight, "px") : undefined) }, (isDefaultSize && {
        width: "100%",
        height: "auto",
        maxWidth: "calc(80 * var(--sjs-base-unit, var(--base-unit, 8px)))",
    })), ((!locImageLink || contentNotLoaded) && { display: "none" }));
    var control = null;
    if (renderedMode === "image") {
        control = (_jsx(Box, { component: "img", src: locImageLink, alt: renderedAltText, sx: style, onLoad: function () { return setContentNotLoaded(false); }, onError: function () { return setContentNotLoaded(true); } }));
    }
    if (renderedMode === "video") {
        control = (_jsx(Box, { component: "video", controls: true, src: locImageLink, sx: style, onLoadedMetadata: function () { return setContentNotLoaded(false); }, onError: function () { return setContentNotLoaded(true); } }));
    }
    if (renderedMode === "youtube") {
        control = (_jsx(Box, { component: "iframe", src: locImageLink, sx: style, title: renderedAltText }));
    }
    var noImage = (!locImageLink || contentNotLoaded) && (_jsx(Box, __assign({ sx: {
            minWidth: "calc(5 * var(--sjs-base-unit, var(--base-unit, 8px)))",
            minHeight: "calc(27.5 * var(--sjs-base-unit, var(--base-unit, 8px)))",
            width: "100%",
            height: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "action.hover",
        } }, { children: _jsx(ImageNotSupportedOutlinedIcon, { sx: { fontSize: 48, opacity: 0.5 } }) })));
    return (_jsxs(Box, __assign({ className: "component-wrapper" }, { children: [control, noImage] })));
};
export default ImageField;
